import { i18n } from "@lingui/core";
import React, { useEffect } from 'react';
import { Link } from 'gatsby';
import { useLingui } from '@lingui/react';
import './projects.scss';
import SEO from '../components/shared/seo';
import shuffleText from '../utils/suffle-text';

var AllProjectsPage = function AllProjectsPage(_ref) {
  var data = _ref.data;
  var projects = data.allSanityProject.edges;

  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  var locale = i18n.locale;
  var newProjects = projects.map(function (_ref2) {
    var _p$title, _p$title2, _p$tags$, _p$tags$$title, _p$tags$2, _p$tags$2$title, _p$client, _p$client2, _p$slug;

    var p = _ref2.node;
    return {
      title: locale === 'en' ? (_p$title = p.title) === null || _p$title === void 0 ? void 0 : _p$title.en : (_p$title2 = p.title) === null || _p$title2 === void 0 ? void 0 : _p$title2.ja,
      // TODO: ugly logic..
      // TODO: type.. temp solution
      tag: p.tags ? locale === 'en' ? (_p$tags$ = p.tags[0]) === null || _p$tags$ === void 0 ? void 0 : (_p$tags$$title = _p$tags$.title) === null || _p$tags$$title === void 0 ? void 0 : _p$tags$$title.en : (_p$tags$2 = p.tags[0]) === null || _p$tags$2 === void 0 ? void 0 : (_p$tags$2$title = _p$tags$2.title) === null || _p$tags$2$title === void 0 ? void 0 : _p$tags$2$title.ja : '',
      client: locale === 'en' ? (_p$client = p.client) === null || _p$client === void 0 ? void 0 : _p$client.en : (_p$client2 = p.client) === null || _p$client2 === void 0 ? void 0 : _p$client2.ja,
      slug: (_p$slug = p.slug) === null || _p$slug === void 0 ? void 0 : _p$slug.current,
      date: new Date(p.publishedAt).getFullYear() + "." + (new Date(p.publishedAt).getMonth() + 1)
    };
  }); // add shuffle effect on text

  useEffect(function () {
    var n = projects.length;
    var ids = [];

    for (var i = 0; i < n; i++) {
      ids.push("date--" + i);
      ids.push("project--" + i);
      ids.push("client--" + i);
      ids.push("maintenance--" + i);
    }

    ids.forEach(function (id) {
      shuffleText(id);
    });
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SEO, {
    title: locale === 'en' ? 'All Projects' : '全てのプロジェクト',
    lang: locale
  }), /*#__PURE__*/React.createElement("div", {
    className: "projects-page"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "projects-page__list"
  }, newProjects.map(function (p, i) {
    return /*#__PURE__*/React.createElement("li", {
      key: p.slug,
      className: "projects-page__item"
    }, /*#__PURE__*/React.createElement("span", {
      id: "date--" + i
    }, p.date), /*#__PURE__*/React.createElement(Link, {
      to: "./" + p.slug
    }, /*#__PURE__*/React.createElement("p", {
      id: "project--" + i
    }, p.title)), p.client && /*#__PURE__*/React.createElement("span", {
      id: "client--" + i
    }, i18n._(
    /*i18n*/
    i18n._("client work")))
    /** client work */
    , (p.tag === 'maintenance' || p.tag === 'メンテナンス中') && /*#__PURE__*/React.createElement("span", {
      id: "maintenance--" + i
    }, p.tag)
    /** maintenance */
    );
  }))));
};

export default AllProjectsPage;
var pageQuery = "210777582";